import {
  isDestoryingAccount,
  openDestoryAccountInfo,
} from "@/components/LoginModal/loginErrHandle";
import { recordRegister } from "@/components/LoginModal/shared";
import useAppStore from "@/context/store";
import { getMe, getSignup, thirdBind, thirdLogin } from "@/services";
import loginTracker from "@/tracker/report/loginTracker";
import registTracker from "@/tracker/report/registTracker";
import { useMemoizedFn } from "ahooks";
import { useCallback, useEffect, useRef } from "react";
import { isGdMerged } from "../gaoding";
import { useLoginAutoMerge } from "../gdMerge";
import histotyDbService from "../historyDB";
import { MSG_TYPE } from "../postMessageToParent";

export enum ThirdLoginMode {
  login,
  bind,
}

export function useThirdLogin(props: {
  mode: ThirdLoginMode;
  onOk?: (data: {
    user: IUser;
    loginType: string;
    isRegister: boolean;
  }) => void;
}) {
  const dataRef = useRef<{ type?: string }>({});

  const loginCb = useMemoizedFn(async (e) => {
    if (e.data.type === MSG_TYPE.thirdLoginOk) {
      // 微信的iframe嵌套页面message消息，不做响应
      if (e.data.isIframe) {
        return;
      }

      window.__login_window.close();
      const result = await getMe();

      props?.onOk?.({
        user: result,
        loginType: dataRef.current.type as MSG_TYPE,
        isRegister: e.data.isRegister,
      });

      unListenCallback();
    } else if (e.data.type === MSG_TYPE.thirdLoginFail) {
      if (isDestoryingAccount(e.data)) {
        openDestoryAccountInfo();

        window.__login_window.close();
        unListenCallback();
      }
    }
  });

  const listenCallback = useMemoizedFn(() => {
    window.addEventListener("message", loginCb);
  });

  const unListenCallback = useMemoizedFn(() => {
    window.removeEventListener("message", loginCb);
  });

  const onThirdLogin = useMemoizedFn((type) => {
    if (props.mode === ThirdLoginMode.bind) {
      thirdBind(type);
    } else {
      thirdLogin(type);
    }

    dataRef.current.type = type;
    // 监听第三方登录状态的变化
    listenCallback();
  });

  useEffect(() => {
    return unListenCallback;
  }, [unListenCallback]);

  return {
    onThirdLogin,
  };
}

export function useThirdLoginCallback({
  onOk = () => {},
}: {
  onOk?: (user: IUser) => void;
} = {}) {
  const autoMerge = useLoginAutoMerge(true);

  const onThirdLoginOk = useCallback(
    async (data: { isRegister?: boolean; loginType: string; user: IUser }) => {
      if (data.isRegister) {
        //记录注册时间点，用于24小时之后触发引导弹窗
        recordRegister();
        // 注册埋点
        registTracker(data.loginType, data.user.user_id);
      } else {
        // 登录埋点
        loginTracker({
          userId: data.user.user_id,
          login_type: data.loginType,
          is_cache_login: false,
        });
      }
      // 本地访问历史记录数据变更用户
      // @ts-ignore
      histotyDbService.changeUser(data.user);

      let user: IUser = data.user;

      // 未融合，有手机号用户走自动融合流程
      if (!isGdMerged(data.user) && data.user.tel) {
        await autoMerge((user || data.user) as IUser);
      }

      user = useAppStore.getState().user || data.user;

      useAppStore.getState().setUser(user);

      onOk && onOk(user);
    },
    [autoMerge, onOk]
  );

  const onWxLoginOk = useCallback(
    async (res) => {
      if (res?.user) {
        const data = {
          loginType: "wechat",
          user: res.user,
        };
        data.loginType = "wechat";
        const user = await getMe();
        data.user = user;
        onThirdLoginOk(data);
      } else {
        await getSignup();
        const user = await getMe();

        onThirdLoginOk({
          isRegister: true,
          loginType: "wechat",
          user,
        });
      }
    },
    [onThirdLoginOk]
  );

  return {
    onThirdLoginOk,
    onWxLoginOk,
  };
}
